import CampaignPage from './CampaignPage';
import './CampaignPage.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Action Creators
import {
  postCampaignCompletionAnswer,
  finishCampaign,
  rateCampaign,
  trackCtaClick
} from '../../redux/campaigns/actions';
import {
  addEngagementAnswer,
  postEngagementAnswers
} from '../../redux/answers/actions';
import {
  // getCardBalance,
  addToBufferAmt
} from '../../redux/loyalty/actions';
import { setLoading } from '../../redux/loading/actions';

// Redux
const mapStateToProps = (state) => {
  return {
    campaigns: state.campaigns,
    answers: state.answers
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // Loading
    setLoading,

    // Campaigns
    postCampaignCompletionAnswer,
    finishCampaign,
    rateCampaign,
    trackCtaClick,

    // Loyalty
    // getCardBalance,
    addToBufferAmt,

    // Answers
    addEngagementAnswer,
    postEngagementAnswers,

  }, dispatch);
}

const ConnectedCampaignPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CampaignPage));

export default ConnectedCampaignPage;



// WEBPACK FOOTER //
// ./src/pages/CampaignPage/index.js